var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 6.1H1.4C.8 6.2.3 6.6.3 7.2c-.1.7.4 1.3 1.1 1.3h16.5c.6-.1 1.1-.5 1.1-1.1 0-.7-.5-1.3-1.1-1.3M1.4 2.4h16.5c.6-.1 1.1-.5 1.1-1.1.1-.7-.4-1.3-1.1-1.3H1.4C.8.1.3.5.3 1.1c-.1.6.4 1.2 1.1 1.3m16.5 9.8H1.2c-.7.1-1.2.7-1.2 1.3.1.7.7 1.2 1.3 1.1h16.5c.6-.1 1.1-.5 1.1-1.1.1-.6-.4-1.2-1-1.3",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamBurger);
export default __webpack_public_path__ + "static/media/hamBurger.6f796ade42eb5d779a5506c24d0e7c1b.svg";
export { ForwardRef as ReactComponent };